export default {
  CREATE: `Create a permission group`,
  DELETE_BUTTON: {
    TITLE: `Delete the permission group`,
    SUMMARY: `Are you sure you want to delete this permission group?`,
    PRIMARY_ACTION: `Delete the permission group`
  },
  LIST: {
    TITLE: `Permission group list`,
    SUMMARY: ``
  },
  IS_DEFAULT: `Is default`,
  PROFILE: `My Profile`,
  SHOW_DAILY: `Daily view`,
  SHOW_WEEKLY: `Weekly view`,
  MINE: `My Home`,
  SHOW_PROJECT_CALENDAR: `Project view`,
  LEAVE: `Manage attendance requests`,
  MY_TIME_OFF: `My Time Off`,
  MY_ATTENDANCE: `My Attendance requests`,
  TIME_OFF: `Manage Time Off`,
  BULLETINS: `Bulletins`,
  PROJECTS: `Projects`,
  REPORT: `Reports`,
  REVOKE: `Revoke`,
  API_TOKEN: `API tokens`,
  ISSUER: `Issuer`,
  INFORMATION: `Information`,
  apiToken: {
    TITLE: `API token list`,
    PRIMARY_ACTION: `Issue new token`,
    SUMMARY: ``
  },
  newToken: {
    TITLE: `New API token`,
    SUMMARY: ``
  },
  ADMIN: {
    TITLE: `Allowed modules and permissions for this company.`,
    SUMMARY: ``,
    SELECT_ALL: `Select all`,
    UNSELECT_ALL: `Unselect all`
  },
  form: {
    TYPE: {
      LABEL: `User type`,
      DESCRIPTION: ``
    },
    CREATE: {
      TITLE: `Creating a permission group`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing a permission group`,
      SUMMARY: ``
    },
    NAMEFR: {
      LABEL: `French permission name`,
      DESCRIPTION: `This name should help you quickly identify the attribute.`,
      PLACEHOLDER: `Enter a name for the permission`
    },
    NAMEEN: {
      LABEL: `English permission name`,
      DESCRIPTION: `This name should help you quickly identify the attribute.`,
      PLACEHOLDER: `Enter a name for the permission`
    },
    IMPORTCODE: {
      LABEL: `Import code`,
      DESCRIPTION: `This will be used in the import tools to assign a group of permission to the users.`,
      PLACEHOLDER: `Enter the import code`
    },
    ISDEFAULT: {
      LABEL: `Default permission`,
      DESCRIPTION: `Will be added to all new users by default.`
    },
    ENABLECHAT: {
      LABEL: `Enable chat`,
      DESCRIPTION: `Allow users in this group to use the chat.`
    },
    LIMITTOREPORTSTO: {
      LABEL: `Limit to reports to`,
      DESCRIPTION: `Prevents users belonging to this permission group from having access to all requests/users.`
    },
    RESTRICTTOPUNCHTERMINAL: {
      LABEL: `Restrict to punch terminal`,
      DESCRIPTION: `The user will only have access to the punch terminal.`
    },
    DEFAULTREPORTSTO: {
      LABEL: `Default reports to field`,
      DESCRIPTION: `Used to determine default views in schedule.`,
      NONE: `None`,
      TEAM: `Team`,
      PROJECT: `Project`
    },
    NAME_REQUIRED: `Permission's name is mandatory.`
  },
  permissionsKey: {
    MONTHLY_VIEW: 'Monthly view',
    WEEKLY_VIEW: 'Weekly view',
    DAILY_VIEW: 'Daily view',
    LIST_CREATION: 'List creation',
    GROUPED_LIST_CREATION: 'Grouped list creation',
    SCHEDULE_SEE_OTHERS: 'See the full schedule schedule',
    SCHEDULE_SEE_COWORKERS: `See coworkers' shifts`,
    SHIFT_CREATION: 'Shift creation',
    SHIFT_MODIFICATION: 'Shift modification',
    SHIFT_DELETION: 'Shift deletion',
    SHIFT_CANCELLATION: 'Shift cancellation',
    SHIFT_PUBLISHING: 'Shift publishing',
    ASSIGN_EMPLOYEE: 'Assign employee to a shift',
    QUICK_ASSIGN: 'Quick assign',
    BULK_CHANGES_CREATE: 'Bulk changes - Create',
    BULK_CHANGES_EDIT: 'Bulk changes - Edit',
    BULK_CHANGES_DELETE: 'Bulk changes - Delete',
    SCHEDULE_TEMPLATE_CREATION: 'Schedule template creation',
    SCHEDULE_TEMPLATE_APPLICATION: 'Schedule template application',
    SEE_SHIFT_HISTORY: 'See shift history',
    SEE_LEAVE: 'See attendance',
    SEE_LEAVE_OTHERS: "See others' attendance requests",
    CREATE_LEAVE: 'Create attendance requests',
    CREATE_LEAVE_OTHERS: "Create others' attendance requests",
    UPDATE_LEAVE: 'Update attendance requests',
    DELETE_LEAVE: 'Delete attendance requests',
    CANCEL_LEAVE: 'Cancel their attendance requests',
    APPROUVE_LEAVE: 'Approve attendance requests',
    UNAPPROUVE_LEAVE: 'Unapprove attendance requests',
    EXPORT_LEAVE: 'Export attendance',
    SEE_TIME_OFF: 'See time off',
    SEE_TIME_OFF_OTHERS: "See others' time off",
    CREATE_TIME_OFF: 'Create time off',
    CREATE_TIME_OFF_OTHERS: "Create others' time off",
    UPDATE_TIME_OFF: 'Update time off',
    DELETE_TIME_OFF: 'Delete time off',
    APPROUVE_TIME_OFF: 'Approve time off',
    UNAPPROUVE_TIME_OFF: 'Unapprove time off',
    EXPORT_TIME_OFF: 'Export time off',
    CANCEL_TIME_OFF: 'Cancel their time off',
    TIME_OFF_CALENDAR_VIEW: 'Time off calendar view',
    SEE_ATTRIBUTE: 'See attributes',
    CREATE_ATTRIBUTE: 'Create attributes',
    UPDATE_ATTRIBUTE: 'Update attributes',
    DELETE_ATTRIBUTE: 'Delete attributes',
    ASSIGN_ATTRIBUTE: 'Assign attributes',
    UNASSIGN_ATTRIBUTE: 'Unassign attributes',
    SEE_FILE: 'See file',
    ADD_FILE: 'Add file',
    REMOVE_FILE: 'Remove file',
    RENEW_ATTRIBUTE: 'Renew skils',
    PROMOTE_ATTRIBUTE: 'Promote attributes',
    DOWN_GRADE_ATTRIBUTE: 'Downgrade attributes',
    SEE_DEPARTMENTS: 'See departments',
    CREATE_DEPARTMENTS: 'Create departments',
    UPDATE_DEPARTMENTS: 'Update departments',
    ASSIGN_DEPARTMENT: 'Assign department',
    UNASSIGN_DEPARTMENT: 'Unassign department',
    DELETE_DEPARTMENTS: 'Delete departments',
    SEE_POSITION_TYPE: 'See position type',
    CREATE_POSITION_TYPE: 'Create position type',
    UPDATE_POSITION_TYPE: 'Update position type',
    DELETE_POSITION_TYPE: 'Delete position type',
    SEE_STRUCTURE: 'See the structure',
    CREATE_STRUCTURE: 'Create structures',
    UPDATE_STRUCTURE: 'Update structures',
    ORDER_STRUCTURE: 'Order structure',
    DELETE_STRUCTUREL: 'Delete structures',
    SEE_USER: 'See the users',
    CREATE_USER: 'Create users',
    UPDATE_USER: 'Update users',
    UPDATE_USER_PERSONNAL_INFO: "Update user's personal information",
    DELETE_USER: 'Delete users',
    APPLICATION_SETTING: 'Modify application settings',
    SEE_REPORT: 'See report',
    SEE_PERMISSIONS_GROUP: "See permission's group",
    CREATE_PERMISSIONS_GROUP: "Create permission's group",
    UPDATE_PERMISSIONS_GROUP: "Update permission's group",
    DELETE_PERMISSIONS_GROUP: "Delete permission's group",
    ASSIGN_PERMISSIONS_GROUP: "Assign permission's group",
    UNASSIGN_PERMISSIONS_GROUP: "Unassign permission's group",
    SEE_REPLACEMENT_LIST: 'See replacement list',
    REPORT_REPLACEMENT_LIST: "Replacement list's report",
    START_REPLACEMENT_LIST: 'Start replacement list',
    USE_REPLACEMENT_LIST: 'Use replacement list',
    NOTIFICATION_REPLACEMENT_LIST: "Replacement list's notifications",
    DELETE_REPLACEMENT_LIST: 'Delete replacement list',
    ARCHIVE_REPLACEMENT_LIST: 'Archive replacement list',
    APPROUVE_REPLACEMENT_LIST: 'Approve replacement list',
    UNAPPROUVE_REPLACEMENT_LIST: 'Unapprove replacement list',
    VIEW_MESSAGES_IN_APP: 'See and accept shifts in the application',
    SCHEDULE_CONFIRMATION: 'Send schedule notifications',
    SEE_PROJECT: 'See projects',
    CREATE_PROJECT: 'Create projects',
    UPDATE_PROJECT: 'Update projects',
    DELETE_PROJECT: 'Delete projects',
    SEE_AVAILABILITIES: 'See their own availabilities',
    EDIT_AVAILABILITIES: 'Make changes or edit their own availabilities',
    APPROVE_AVAILABILITY: 'Approve availabilities',
    REQUEST_CHANGE_AVAILABILITY: 'Request availability changes',
    REQUEST_TEMPORARY_AVAILABILITY: 'Request temporary availability for a specific period',
    IMPORT_USER: 'Import users',
    IMPORT_CLIENT: `Import clients`,
    IMPORT_PROJECT: `Import projects`,
    HIRING_DATA: 'Hiring data',
    SEE_HIRING_DATA: 'See hiring data',
    CREATE_HIRING_DATA: 'Create hiring data',
    UPDATE_HIRING_DATA: 'Update hiring data',
    DELETE_HIRING_DATA: 'Delete hiring data',
    MANAGE_PROJECT_CLIENTS: "Manage project's clients",
    SEE_FILTERS: 'See filters',
    MANAGE_FILTERS: 'Manage filters',
    SEE_AUDIT: 'See audit logs',
    SEE_AUDIT_OTHERS: "See all users' audit logs",
    CREATE_REQUESTS_FIELDS: 'Create request options',
    MANAGE_REQUESTS_FIELDS: 'Manage request options',
    DELETE_REQUESTS_FIELDS: 'Delete request options',
    UPDATE_REQUESTS_FIELDS: 'Update request options',
    CONFIRM_DELETE_GROUP: 'Are you sure you want to delete this group?',
    SCHEDULE_PERMISSION_GROUP: 'Schedule',
    LEAVE_PERMISSION_GROUP: 'Attendance',
    TIME_OFF_PERMISSION_GROUP: 'Time off',
    REPLACEMENT_LIST_PERMISSION_GROUP: 'Replacement list',
    ATTRIBUTES_PERMISSION_GROUP: 'Attributes',
    DEPARTMENTS_PERMISSION_GROUP: 'Departments',
    STRUCTURE_PERMISSION_GROUP: 'Structure',
    USER_PERMISSION_GROUP: 'Users',
    PERMISSIONS_PERMISSION_GROUP: 'Permissions management',
    SETTINGS_PERMISSION_GROUP: 'Settings',
    REPORTS_PERMISSION_GROUP: 'Reports',
    AVAILABILITIES_PERMISSION_GROUP: 'Availabilities',
    BULLETIN_PERMISSION_GROUP: 'Bulletin',
    HIRING_DATA_PERMISSION_GROUP: 'Hiring data',
    PROJECTS_PERMISSION_GROUP: 'Project',
    REQUEST_FIELDS_PERMISSION_GROUP: 'Request field',
    AUDIT_PERMISSION_GROUP: 'Audit',
    FILTERS_PERMISSION_GROUP: 'Filters',
    VACATION_DISTRIBUTION_PERMISSION_GROUP: 'Vacation distributions',
    SEE_VACATION_DISTRIBUTION: 'See vacation distributions',
    CREATE_VACATION_DISTRIBUTION: 'Create a vacation distribution',
    UPDATE_VACATION_DISTRIBUTION: 'Update a vacation distribution',
    DELETE_VACATION_DISTRIBUTION: 'Delete a vacation distribution',
    MAKE_CHOICES_VACATION_DISTRIBUTION: 'Make choices in a vacation distribution',
    SEE_OTHERS_CHOICES_VACATION_DISTRIBUTION: "See others' choices in a vacation distribution",
    UPDATE_OTHERS_CHOICES_VACATION_DISTRIBUTION: 'Update others choices in a vacation distribution',
    FORCE_OTHERS_CHOICES_VACATION_DISTRIBUTION: 'Force users choice to be valid in a vacation distribution',
    IMPORT_CONFIG_PERMISSION_GROUP: 'Import',
    SEE_IMPORT_CONFIG: 'See import config',
    UPDATE_IMPORT_CONFIG: 'Update import config',
    CREATE_IMPORT_CONFIG: 'Create import config',
    DELETE_IMPORT_CONFIG: 'Delete import config',
    UPDATE_USER_HIRING_INFO: "Update user's hiring information",
    UPDATE_USER_CONTACT_INFO: "Update user's contact information",
    UPDATE_USER_CONNECTION_INFO: "Update user's connection information",
    SHIFT_SWAP_PERMISSION_GROUP: 'Shift swap',
    CAN_CONFIRM_SWAP: 'Can confirm',
    SHIFT_SWAP_SEE_OTHERS: "Can see others' swap",
    DELETE_SHIFT_SWAP: 'Delete shift Swap',
    API_TOKEN: 'API token',
    API_TOKEN_MODAL: 'API tokens for permissions group: ',
    ISSUER: 'Issuer',
    INFORMATIONS: 'Information',
    ISSUE_NEW_TOKEN: 'Issue a new token',
    REVOKE: 'Revoke',
    TAGS_PERMISSION_GROUP: 'Tags',
    HOLIDAYS_PERMISSION_GROUP: `Holidays`,
    SEE_TAGS: 'See tags',
    CREATE_TAGS: 'Create tags',
    UPDATE_TAGS: 'Update tags',
    DELETE_TAGS: 'Delete tags',
    MANAGE_HOLIDAYS: 'Manage holidays',
    STATISTICS_PERMISSION_GROUP: 'Statistics',
    SEE_STATISTICS: 'See statistics',
    IMPORT_ATTRIBUTE: 'Import attribute',
    IMPORT_PERMISSION_GROUP: 'Import',
    USER_PROCEDURES_PERMISSION_GROUP: 'Procedures',
    SEE_PROCEDURES: 'See procedures',
    MANAGE_PROCEDURES: 'Manage procedures',
    USER_SORTS_PERMISSION_GROUP: 'Sorts',
    SEE_SORTS: 'See sorts',
    MANAGE_SORTS: 'Manage sorts',
    USER_FILTERS_PERMISSION_GROUP: 'Filters',
    GENERATE_API_TOKEN: 'Generate API tokens',
    SEND_ONBOARDING_LINK: 'Send onboarding link',
    CONTACT_LIST_PERMISSION_GROUP: 'Contacts lists',
    SEE_CONTACT_LIST: 'See contacts lists',
    DELETE_CONTACT_LIST: 'Delete contacts lists',
    APPROUVE_CONTACT_LIST: 'Approve contacts lists',
    NOTIFICATION_CONTACT_LIST: 'Notifications in contacts lists',
    ARCHIVE_CONTACT_LIST: 'Archive contacts lists',
    UNAPPROUVE_CONTACT_LIST: 'Unapprove contacts lists',
    SEE_SCHEDULE_CAPACITY: 'See and calculate schedule capacity',
    SEE_USER_PERSONNAL_INFO: "See the user's personal information",
    SEE_USER_HIRING_INFO: "See the user's hiring information",
    SEE_USER_CONTACT_INFO: "See the user's contact information",
    SEE_USER_CONNECTION_INFO: "See the user's connection information",
    SEE_USER_PAY_INFO: `See the user's pay information`,
    SEE_OTHERS_AVAILABILITIES: "See the others' availabilities",
    EDIT_OTHERS_AVAILABILITIES: "Modify others' availabilities",
    IMPORT_STRUCTURE: 'Import structures',
    IMPORT_SCHEDULE: 'Import schedule events',
    IMPORT_VACATION: 'Import vacations',
    IMPORT_DISPONIBILITY: 'Import availability',
    IMPORT_ATTRIBUTE_ASSIGNATION: 'Import attribute assignments',
    SCHEDULE_SEE_MINE: 'See my schedule',
    CAN_SWAP_OTHERS: "Can swap others' shift",
    VIEW_CONTACT_REPORTS: 'View contact reports',
    BREAKS_PERMISSION_GROUP: 'Breaks',
    SEE_BREAKS: 'See breaks',
    CREATE_BREAKS: 'Create breaks',
    UPDATE_BREAKS: 'Update breaks',
    DELETE_BREAKS: 'Delete breaks',
    COMMENTS: 'Comments',
    ATTACHMENTS: `Attachments`,
    CONTACT_PERMISSION_GROUP: 'Contact',
    BOOST_CONTACT: 'Boost contact list (ex: modify the amount of simultaneous calls)',
    SEE_BULLETIN: 'See the bulletin board',
    SEE_READ_BY_BULLETIN: 'See who has read bulletins',
    MANAGE_BULLETIN: 'Manage my bulletins',
    MANAGE_OTHERS_BULLETIN: 'Manage others bulletins',
    SEND_BULLETIN_NOTIFICATIONS: 'Send bulletin notifications',
    CONTACT_LIST_CONFIGS_PERMISSION_GROUP: 'Contact list configuration',
    CREATE_CONFIGS: 'Create configurations configurations',
    UPDATE_CONFIGS: 'Edit configurations configurations',
    DELETE_CONFIGS: 'Delete configurations',
    ARCHIVE_USER: 'Archive user',
    SEE_DIFF: 'See user history modifications',
    PUNCHCARDS_PERMISSION_GROUP: 'Punch cards',
    SEE_PUNCHCARDS: 'See punch cards',
    PUNCHTERMINAL_PERMISSION_GROUP: 'Punch terminal',
    START_PUNCH_TERMINAL: 'Launch punch terminal session',
    PUNCH_ON_SHIFTS: 'Punch on their own shifts',
    SEE_OWN_PUNCHES: 'View their own punches',
    DELETE_PUNCHCARDS: 'Delete punch cards',
    MODIFY_PUNCHCARDS: 'Modify/Create punch cards',
    MODIFY_LOCKED_PUNCHCARDS: 'Modify/Create locked punch cards',
    CHANGE_PUNCH_LOCK: 'Modify punch card lock date',
    ENABLE_APPROVE_OWN_PUNCH_CARD: 'Enable approve own punch card',
    TEAMS: 'Teams',
    TEAMS_PERMISSION_GROUP: 'Teams module',
    MODIFY_TEAMS: 'Modify teams',
    DELETE_TEAMS: 'Delete teams',
    PUNCHRULES_PERMISSION_GROUP: 'Punch rules',
    MANAGE_PUNCH_RULES: 'Manage punch rules',
    SEE_TIME_OFF_PAGE: 'See time-off page',
    UPDATE_REPLACEMENT_STATUS: 'Update replacement status',
    PROFILE_PERMISSION_GROUP: 'Employee Profile',
    UPDATE_PHONE_NUMBERS: 'Update phone numbers',
    UPDATE_CONTACT_EMAILS: 'Update contact emails',
    FINALIZE_SHIFT: 'Finalize shift',
    MANAGE_SPECIFIC_RESTRICTIONS: 'Manage Specific Restrictions',
    SCHEDULE_TYPES_PERMISSION_GROUP: 'Schedule type permission',
    MANAGE_SCHEDULE_TYPES: 'Manage schedule type',
    PAY_PERMISSION_GROUP: 'Pay permissison',
    MANAGE_WAGE_PREMIUM: 'Manage wage premiums',
    OVERRIDE_WAGE_PREMIUM: 'Override automatic overtime wage premium caculation',
    SEE_COMMENTS_OTHERS: `See others' comments`,
    BACK_TO_PERMISSIONS_MGMT: 'Back to permission management',
    LIST_CONFIG_PERMISSION_GROUP: 'Filter/Sort/Configurations',
    SEE_LIST_CONFIGS: 'View list configurations',
    MANAGE_LIST_CONFIGS: 'Modify list configurations',
    CONTACT_LOGS_PERMISSION_GROUP: 'Contact logs',
    SEE_CONTACT_LOGS: 'See the contact logs',
    CAN_SEE_MODULE: 'Can see the module',
    MANAGE_PERMISSIONS_GROUP: 'Manage permission groups',
    SEE_SCHEDULE_ISSUES: 'See schedule issues',
    ALLOWED_PERMISSIONS: 'Allowed permissions',
    MODIFY_ALLOWED_PERMISSIONS: "Modify a company's allowed permissions",
    IMPORT_PUNCH: 'Import punch data',
    POSITIONS: 'Positions',
    CREATE_GROUP: 'Create a permission group',
    DEFAULT_PATH: 'Default login page',
    DEFAULT_PATH_DESC: 'When a user logs in, they will be directed to this page.',
    PATH_PRIORITY: 'Default page priority',
    PATH_PRIORITY_DESC: 'Priority of the page (useful if a user has multiple permission group)',
    DEFAULT_HELP_URL: 'Default help article URL',
    DEFAULT_HELP_URL_DESC: 'When clicking on the question mark in the sidebar, the user will be brought to this help article',
    HELP_URL_PRIORITY: 'Help article priority',
    HELP_URL_PRIORITY_DESC: 'Priority of the help article (useful if a user has multiple permission group)',
    IMPORT_CODE_DESC: 'A code must be provided in order to add permissions groups to users during user import',
    EMPLOYEE_PORTAL_PERMISSION_GROUP: 'Employee portal',
    SEE_EMPLOYEE_PORTAL: 'See employee portal',
    ACKNOWLEDGE_LEAVE: 'Acknowledge attendance requests',
    JUSTIFY_LEAVE: 'Mark attendance requests as justified or unjustified'
  }
}
